var exports = {
  "nM": "row__te3HgX",
  "Kk": "icon__9qutgd",
  "ik": "errorIcon__TBLxei",
  "Qq": "text__4UoCIV",
  "lN": "emphasis__rtuYMh",
  "_0": "detail__48v-y8",
};

module.exports = exports;
